import {athubAxios} from "../../../util/athub-axios";

const menu = {
    findById: findById,
    menus: selectMenus,
    availableMenus: selectAvailableMenus,
    menusSelect: selectMenusSelect,
    menusSelectLazy: selectMenusSelectLazy,
    checkName: checkMenuNameAvailable,
    checkCode: checkMenuCodeAvailable,
    add: add,
    update: update,
    selectPage: selectPage,
    fullPath: selectFullPathById,
    invalidate: invalidate,
    revalidate: revalidate,
};

import {ORGANIZATION_SERVER} from '@/api/server'

/**
 * 菜单停用
 * @param id 菜单ID
 */
export function invalidate(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/invalidate/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 菜单重新启用
 * @param id 菜单ID
 */
export function revalidate(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/revalidate/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 根据菜单ID查询菜单详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 添加菜单信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/menu`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 修改菜单信息
 * @param id 菜单ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/menu/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

export function selectMenus(version) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/tree?version=${version}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

export function selectAvailableMenus(version) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/available/tree?version=${version}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

export function selectMenusSelect(version) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/select?version=${version}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

export function selectMenusSelectLazy(id) {
    return new Promise((resolve, reject) => {
        let suffix = '';
        if (id != null) {
            suffix = '?id=' + id;
        }
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/select/lazy/${suffix}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 分页查询菜单列表
 * @param param 搜索参数
 * @returns {Promise<unknown>}
 */
export function selectPage(param) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/menu/selectPage`, param)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 检查菜单名称是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkMenuNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/menu/check`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 检查菜单编码是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkMenuCodeAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/menu/checkCode`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}


/**
 * 根据菜单ID查询菜单全路径
 * @param id 菜单ID
 * @return 菜单全路径
 */
export function selectFullPathById(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/menu/path/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

export default menu;
